import { render, staticRenderFns } from "./direct.vue?vue&type=template&id=2ab2c996&scoped=true&lang=pug&"
import script from "./direct.vue?vue&type=script&lang=ts&"
export * from "./direct.vue?vue&type=script&lang=ts&"
import style0 from "./direct.vue?vue&type=style&index=0&id=2ab2c996&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2c996",
  null
  
)

export default component.exports